import { css } from "@emotion/css";
import type React from "react";
interface ProcessTemplateIconEditLayoutProps {
    iconEditor: React.ReactElement;
}
const ProcessTemplateIconEditLayout = ({ iconEditor }: ProcessTemplateIconEditLayoutProps) => {
    return <div className={styles.content}>{iconEditor}</div>;
};
export default ProcessTemplateIconEditLayout;
const styles = {
    content: css({
        display: "flex",
        flexDirection: "column",
        justifyContent: "flex-start",
        overflow: "visible",
        width: "375px",
        "@media (max-width: @screen-sm)": {
            width: "100%",
            gridAutoRows: "auto",
        },
    }),
};
